
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"data-name":"Group 133057","xmlns":"http://www.w3.org/2000/svg","width":"31","height":"31","viewBox":"0 0 31 31"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"chevron_right"}},[_c('path',{attrs:{"data-name":"Union 1","d":"M10.203 14.304l6.475-6.757a1.363 1.363 0 01.955-.395 1.321 1.321 0 01.943.395 1.369 1.369 0 01.018 1.888l-.006.011-5.574 5.8 5.58 5.818a1.362 1.362 0 01-.018 1.882l-.016.022a1.423 1.423 0 01-.945.361 1.3 1.3 0 01-.938-.384h-.012l-6.463-6.746a1.311 1.311 0 01-.389-.949 1.306 1.306 0 01.39-.946z","fill":"#717b8c"}})])])
          )
        }
      }
    